// extracted by mini-css-extract-plugin
export default {"heading":"SinglePageContainer_heading__Tsunp","pageTitle":"SinglePageContainer_pageTitle__3mIfN"};